export default theme => ({
    featuredIconsInner: {
        position: 'relative',
        '& p': {
            color: theme.palette.secondary.contrastText,
        },
        '& .gatsby-image-wrapper': {
            width: 128,
            margin: 0,
            [theme.breakpoints.up('md')]: {
                margin: '0 auto 30px',
            }
        }
    },
    featuredIconsInnerTheme: {
        ...theme.featuredIconsInnerTheme,
    }
})